<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasModuleGerencia || hasRoleGestorCompras"
             color="primary" class="normal-btn-text rounded-tag-small elevation-0"
             link to="/centros-custo/cadastro">
        <v-icon left>mdi-plus</v-icon>
        Centro de Custo
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque pelo centro de custo"
                      class="rounded-tag-small" v-model="searchText"
                      style="max-width: 400px"
                      :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('listagemCentroCusto', ['stringFilter']),
    ...mapGetters('user', ['hasModuleGerencia', 'hasRoleGestorCompras']),
    searchText: {
      get() {
        return this.$store.getters['listagemCentroCusto/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemCentroCusto/searchText', searchText);
      },
    },
  },
  methods: {
    onChangeSearchText() {
      this.onChangeFilter(this.stringFilter);
    },
    onSelectItem() {
      this.onChangeFilter(this.stringFilter);
    },
  },
};
</script>
